import(/* webpackMode: "eager" */ "/var/www/Fixr/frontend/app/blogs/page.tsx");
